
import startCase from 'lodash/startCase'

export default {
  name: 'EboardPositions',
  async asyncData({ req, context, i18n }) {
    let currentLocale = i18n.locale
    if (currentLocale == 'en') {
      const positions = await import('~/static/data/eboard-positions-en.json').then((m) => m.default || m)
      return positions
    }
    else {
      const positions = await import('~/static/data/eboard-positions-ar.json').then((m) => m.default || m)
      return positions
    }

  },
  data() {
    return {
      headers: this.$t('positions.headers'),
      selectedPosition: null,
    }
  },
  computed: {
    currentPositions() {
      var d = this.positions.filter((position) =>  this.$dayjs().isBefore(this.$dayjs(position.to, 'DD/MM/YYYY').add(1, 'day')));
      // var d = this.positions.filter((position) => position.status == 'open' || position.status == 'متاح')
      return d.reverse()
    },
    previousPositions() {
      // filter the position where the to date is less than the current date
      var d = this.positions.filter((position) => this.$dayjs(position.to, 'DD/MM/YYYY').add(1, 'day').isBefore(this.$dayjs()));
      // var d = this.positions.filter((position) => position.status == 'closed' || position.status == 'مغلق')
      return d.reverse()
    },
  },
  methods: {
    openModal(modal, position) {
      this.selectedPosition = position
      this.activeModal = modal
      this.$refs[modal].showModal = true
    },
    closeModal(modal) {
      this.$refs[modal].showModal = false
    },

    startCase(str) {
      return startCase(str)
    },
  },
}
